__turbopack_context__.v({
  "container": "_6kiwyW_container",
  "hasSquareBorders": "_6kiwyW_hasSquareBorders",
  "shortContainer": "_6kiwyW_shortContainer",
  "video-js": "_6kiwyW_video-js",
  "videoPlayer": "_6kiwyW_videoPlayer",
  "vjs-control-bar": "_6kiwyW_vjs-control-bar",
  "vjs-loading-spinner": "_6kiwyW_vjs-loading-spinner",
});
